import HOCWatchValue from 'components/common/hoc-watch-value';
import TableInput from 'components/elements/table/table-input';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function InformationCruiseTable() {
  const { t } = useTranslation();

  const name = 'cruisePurchases';
  const _value = HOCWatchValue({ keys: [name] })[name][0];

  const value = {
    ..._value,
    departureTime: _value.startedAt,
    arrivalTime: _value.endedAt,
  };

  const columns: IColumn<any>[] = [
    {
      header: t('common:cruise_line'),
      accessorKey: 'cruiseName',
      minSize: 180,
      maxSize: 200,
      dataType: ColumnDataType.text,
    },
    {
      header: t('cruise:ship'),
      accessorKey: 'cruiseShipName',
      minSize: 180,
      maxSize: 200,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:from'),
      accessorKey: 'startedAt',
      minSize: 150,
      maxSize: 150,
      dataType: ColumnDataType.date,
    },
    {
      header: t('common:to'),
      accessorKey: 'endedAt',
      minSize: 150,
      maxSize: 150,
      dataType: ColumnDataType.date,
    },
    {
      header: t('common:departure'),
      accessorKey: 'departureTime',
      minSize: 100,
      maxSize: 150,
      dataType: ColumnDataType.time,
    },
    {
      header: t('common:arrival'),
      accessorKey: 'arrivalTime',
      minSize: 100,
      maxSize: 150,
      dataType: ColumnDataType.time,
    },
    {
      header: t('common:route'),
      accessorKey: 'route',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns}
        data={[value]}
        dispatch={() => {}}
        disabled
        name={name}
        uniqueRowKey="customId"
      />
    </div>
  );
}
